export const isNode = false;




//////////////////
// WEBPACK FOOTER
// ./node_modules/detect-node-es/esm/browser.js
// module id = 1191
// module chunks = 0